
import { DrawingCard } from "./DrawingCard";
import { Button } from "@/components/ui/button";
import { Tables } from "@/integrations/supabase/types";
import { CirclePlus } from "lucide-react";

type Drawing = Tables<"whiteboard_history"> & {
  drawing_analyses?: {
    id: string;
    procedure_type: string;
    analysis_text: string;
    created_at: string;
    drawing_id: string;
    key_points: Json | null;
    status: "pending" | "completed" | "failed";
    updated_at: string;
    user_id: string;
  }[];
};

type Json =
  | string
  | number
  | boolean
  | null
  | { [key: string]: Json | undefined }
  | Json[]

interface DrawingsGridProps {
  drawings: Drawing[];
  loadedImages: Set<string>;
  loadingDrawingId: string | null;
  hasMore: boolean;
  onLoad: (id: string) => void;
  onDelete: (id: string) => void;
  onLoadMore: () => void;
}

export function DrawingsGrid({
  drawings,
  loadedImages,
  loadingDrawingId,
  hasMore,
  onLoad,
  onDelete,
  onLoadMore
}: DrawingsGridProps) {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-2 md:grid-cols-2">
        {drawings.map((drawing) => (
          <DrawingCard
            key={drawing.id}
            drawing={drawing}
            isImageLoaded={loadedImages.has(drawing.id)}
            loadingDrawingId={loadingDrawingId}
            onLoad={onLoad}
            onDelete={onDelete}
          />
        ))}
      </div>
      
      {hasMore && (
        <div className="flex justify-center pt-2">
          <Button 
            variant="outline" 
            onClick={onLoadMore}
            className="w-full max-w-md bg-background/70 hover:bg-background/90 border-dashed border-muted-foreground/30 text-muted-foreground shadow-sm transition-all duration-200 group"
          >
            <CirclePlus className="h-4 w-4 mr-2 text-muted-foreground/70 group-hover:text-primary/80 transition-colors" />
            <span className="group-hover:text-foreground transition-colors">Load more drawings</span>
          </Button>
        </div>
      )}
    </div>
  );
}
